import * as React from "react";
const SvgFiRrCustomizeComputer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-customize-computer_svg__a)">
      <path
        fill="#062147"
        d="M14.988 12.726A3 3 0 0 1 12 16H8.022a1.02 1.02 0 0 1-.975-1.325c.502-1.609 1.936-4.165 4.24-4.608 1.755-.338 3.543.879 3.701 2.659M23 9a1 1 0 0 0-1 1v5c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h8a1 1 0 1 0 0-2H5C2.243 2 0 4.243 0 7v8c0 2.757 2.243 5 5 5h6v2H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-2h6c2.757 0 5-2.243 5-5v-5a1 1 0 0 0-1-1m-9.414-.315.022.01a.97.97 0 0 0 1.109-.254l5.641-6.13a.945.945 0 0 1 1.334-.074l.038.036a.943.943 0 0 1 .001 1.334l-.001.001-5.844 5.686a.985.985 0 0 0-.123 1.237l.011.017a.98.98 0 0 0 1.522.162l5.844-5.685a2.947 2.947 0 0 0 0-4.163A2.943 2.943 0 0 0 18.978.86c-.039.039-5.761 6.256-5.761 6.256-.455.511-.259 1.298.369 1.569"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-customize-computer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCustomizeComputer;
